import {
  BotaoCabecalho,
  CabecalhoComBotao,
  CabecalhoComBotaoMobile,
  CabecalhoContainer,
  CabecalhoContainerMobile,
  CardLoja,
  CardLojaContainerDireita,
  CardLojaImage,
  Container,
  ContainerCardsLoja,
  IconeBotao,
  LinhaCabecalhoComBotao,
  TextoBotaoCabecalho,
  TextoCabecalhoCardLoja,
  TextoCabecalhoComBotao,
  TextoNumeroDaLoja,
  TextoTipoCardLoja,
  Painel,
  Divisor,
} from "./styles";
import { useNavigate } from "react-router-dom";
import logoLoja from "../../assets/images/logoLoja.jpg";
import { X } from "phosphor-react";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import { useApi } from "../../contexts/api";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/auth";
import { NavegacaoHeader } from "../../components/NavegacaoHeader";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useMenu } from "../../contexts/menu";
import { useLoader } from "../../contexts/loader";
import Footer from "../../components/Footer";

export default function SelecaoEmpresas() {
  const theme = useTheme();

  const { get } = useApi();

  const { trocarEmpresa } = useAuth();

  const { buscarDadosEmpresaStorage, dadosEmpresa, buscarDashboards } = useMenu();

  const navigate = useNavigate();

  const [empresas, setEmpresas] = useState([]);
  const { headerFixo } = useMenu();

  const { abrirCarregamento, fecharCarregamento } = useLoader();

  useEffect(() => {
    obterDados();
  }, []);

  function obterDados() {
    get("/usuario-sessao/usuario/buscar-empresas-disponiveis")
      .then((response) => {
        setEmpresas(response.data);
      })
      .catch((error) => {
        toast.error("Desculpe! Houve um erro ao obter as empresas disponíveis");
      });
  }

  function selecionarEmpresa(empresa) {
    try {
      abrirCarregamento(`Carregando ${empresa.apelido}...`);
      trocarEmpresa(empresa)
        .then(async (dados) => {
          await buscarDashboards(dados.tokenDTO.token);
          await buscarDadosEmpresaStorage();
          toast.success("Empresa alterada com sucesso!");
          setTimeout(() => {
            fecharCarregamento().then(() => {
              window.location.href = "/";
            });
          }, 500);
        })
        .catch((erro) => {
          fecharCarregamento().then(() => {
            toast.error("Não foi possivel alterar empresa!");
          });
        });
    } catch (error) {
      fecharCarregamento().then(() => {
        toast.error("Não foi possivel alterar empresa3!");
      });
    }
  }

  const ItemEmpresa = ({ empresa }) => {
    return (
      <CardLoja
        onClick={() => selecionarEmpresa(empresa)}
        empresaSelecionada={empresa.apelido == dadosEmpresa.apelido ? true : false}
      >
        <CardLojaImage
          src={
            empresa.logo == null || empresa.logo == ""
              ? logoLoja
              : `data:image/jpg;base64,${empresa.logo}`
          }
        />
        <CardLojaContainerDireita>
          <TextoCabecalhoCardLoja>{empresa.apelido}</TextoCabecalhoCardLoja>
          <TextoTipoCardLoja>{empresa.tipoEmpresa}</TextoTipoCardLoja>
          <TextoNumeroDaLoja>
            Número da Loja: {empresa.numeroLoja?.toString().padStart(2, "0")}
          </TextoNumeroDaLoja>
        </CardLojaContainerDireita>
      </CardLoja>
    );
  };

  function voltarHome() {
    navigate("/");
  }

  return (
    <>
      <Container>
        <Painel>
          <NavegacaoHeader titulo={"Selecionar empresa"} headerFixo={headerFixo} />
          <Divisor headerFixo={headerFixo} />
          <ContainerCardsLoja>
            {empresas.map((empresa, index) => {
              return <ItemEmpresa empresa={empresa} key={`${index}+${empresa.idEmpresa}`} />;
            })}
          </ContainerCardsLoja>
        </Painel>
      </Container>
      <Footer caminho={["Selecionar empresa"]} />
    </>
  );
}
